var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4802 12.5424L9.98084 6.29105C9.12797 5.8646 8.11518 5.90885 7.30426 6.41014C6.49335 6.91144 6 7.79718 6 8.74987V8.83153C6 9.18197 6.06691 9.52901 6.19734 9.85338L8.25579 15.0011L6.19734 20.1488C6.06691 20.4732 6 20.8202 6 21.1707V21.2523C6 22.205 6.49335 23.0907 7.30426 23.5921C8.11518 24.0934 9.12794 24.1376 9.98084 23.7111L22.4802 17.4598C23.4114 16.9948 24 16.0422 24 15.001C24 13.9599 23.4114 13.0074 22.4802 12.5424ZM21.7011 15.9039L9.19385 22.152C8.88197 22.3051 8.51335 22.287 8.21848 22.1044C7.92362 21.9218 7.74329 21.5997 7.74215 21.2526V21.171C7.74329 21.0462 7.76824 20.9237 7.81474 20.8081L9.77453 15.8723H14.7103V14.1302H9.77453L7.81474 9.19447C7.76824 9.07879 7.74329 8.95631 7.74215 8.83155V8.74989C7.74329 8.40285 7.92362 8.08075 8.21848 7.89815C8.51335 7.71556 8.88197 7.69741 9.19385 7.85052L21.7011 14.0986C22.0436 14.2687 22.2591 14.6181 22.2591 15.0003C22.2591 15.3813 22.0436 15.7307 21.7011 15.9019V15.9039Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendarrow);
export default __webpack_public_path__ + "static/media/sendarrow.792cdc71d155f9cdd15bb20a619383fd.svg";
export { ForwardRef as ReactComponent };